import React from 'react';
import { motion } from 'framer-motion';
import { Users, Briefcase, Scale, GraduationCap, Clock } from 'lucide-react';
export const Audience = () => {
  const audience = [{
    icon: <Briefcase className="w-5 h-5" data-id="element-19" />,
    text: 'Abogados independientes.'
  }, {
    icon: <Users className="w-5 h-5" data-id="element-20" />,
    text: 'Estudios jurídicos.'
  }, {
    icon: <Scale className="w-5 h-5" data-id="element-21" />,
    text: 'Profesionales que trabajan o desean trabajar casos de obras sociales y prepagas.'
  }, {
    icon: <GraduationCap className="w-5 h-5" data-id="element-22" />,
    text: 'Abogados que reciben consultas vinculadas al derecho a la salud.'
  }, {
    icon: <Clock className="w-5 h-5" data-id="element-23" />,
    text: 'Profesionales que buscan ahorrar tiempo y contar con material práctico listo para aplicar.'
  }];
  return <section className="py-20 bg-legal-900" data-id="element-24">
      <div className="container mx-auto px-4" data-id="element-25">
        <div className="max-w-4xl mx-auto" data-id="element-26">
          <div className="text-center mb-12" data-id="element-27">
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-6" data-id="element-28">
              ¿A quién va dirigido?
            </h2>
            <p className="text-lg text-slate-400" data-id="element-29">
              Este tratado fue creado específicamente para potenciar la práctica
              legal diaria.
            </p>
          </div>

          <div className="bg-legal-800 rounded-2xl p-8 md:p-12 border border-legal-700 shadow-xl" data-id="element-30">
            <ul className="space-y-6 mb-10" data-id="element-31">
              {audience.map((item, idx) => <motion.li key={idx} initial={{
              opacity: 0,
              y: 10
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4,
              delay: idx * 0.1
            }} className="flex items-start gap-4 text-slate-300 text-lg" data-id="element-32">
                  <div className="mt-1 p-1.5 bg-legal-900 text-gold-500 rounded-md shrink-0" data-id="element-33">
                    {item.icon}
                  </div>
                  <span className="leading-relaxed" data-id="element-34">{item.text}</span>
                </motion.li>)}
            </ul>

            <div className="bg-legal-900/50 border-l-4 border-gold-500 p-6 rounded-r-lg" data-id="element-35">
              <p className="text-slate-300 font-medium italic" data-id="element-36">
                No importa si recién comenzás en la materia o si ya llevás casos
                de salud: el objetivo es brindarte herramientas concretas para
                trabajar con mayor seguridad, rapidez y respaldo jurídico. 📚✨
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
};